/**
 * Coarse page-type buckets for performance reporting.
 *
 * Deliberately the SAME taxonomy the CDN log rollup uses
 * (`dags/ops/web_perf_cdn_rollup.py` -> `core_schema.web_perf_cdn_hourly`), so
 * field vitals and origin TTFB can be compared template by template on one
 * dashboard. If you add a bucket here, add the matching CASE arm there too or
 * the two datasets stop lining up.
 *
 * This is intentionally coarser than `Utils/normalized-pathname`: that returns
 * the route template (~40 values, good for drilling in), this returns the 8
 * buckets the dashboards group by.
 */
export const PAGE_TYPES = {
  HOME: 'home',
  TOPIC: 'topic',
  PROFILE: 'profile',
  ARTICLE: 'article',
  VIDEO: 'video',
  SECTION: 'section',
  MAGAZINE: 'magazine',
  OTHER: 'other',
};

/**
 * @param {String} pathname - a raw location pathname, e.g. '/topic/technology'
 * @return {String}         - one of PAGE_TYPES
 */
const pageType = (pathname) => {
  if (typeof pathname !== 'string' || pathname.length === 0) {
    return PAGE_TYPES.OTHER;
  }
  // CloudFront logs the path percent-encoded, so '/@handle' arrives as '/%40handle'
  // there; normalize the same way here so both sides bucket a profile identically.
  const path = pathname.replace(/^\/%40/i, '/@');

  if (path === '/') {
    return PAGE_TYPES.HOME;
  }
  if (path.indexOf('/topic/') === 0) {
    return PAGE_TYPES.TOPIC;
  }
  if (path.indexOf('/@') === 0) {
    return PAGE_TYPES.PROFILE;
  }
  if (path.indexOf('/article/') === 0) {
    return PAGE_TYPES.ARTICLE;
  }
  if (path.indexOf('/video/') === 0) {
    return PAGE_TYPES.VIDEO;
  }
  if (path.indexOf('/section/') === 0) {
    return PAGE_TYPES.SECTION;
  }
  if (path.indexOf('/magazine/') === 0 || path.indexOf('/magazines/') === 0) {
    return PAGE_TYPES.MAGAZINE;
  }
  return PAGE_TYPES.OTHER;
};

export default pageType;
